<template>
  <div class="row categories">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.infoPagesCustom')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-lg-12 col-md-10 col-sm-12 ">

      <div class="card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="card-content row">
          <div class="col-sm-12">
            <div class="pull-right" style="position:relative;z-index:2">
              <router-link class="btn btn-info add mar-bt-20" title="" :to="{ path: 'custom-info-pages/add'}">
                <img src="/static/img/icons/add.png">
                {{$t('general.add')}} {{$t('infoPages.single')}}
              </router-link>
            </div>
          </div>
          <table class="table width-table" ref="sortableTable">
            <thead>
              <tr>
                <th width="10%"></th>
                <th width="60%">{{$t('catalogCateg.name')}}</th>
                <th width="10%"></th>
              </tr>
            </thead>
            <draggable v-model="pages" :element="'tbody'" @end="adjustSort">
              <template v-for="(item, index) in pages">
                <tr  v-if="item.type === 'CUSTOM'" class="sortableRow" :key="index.id" @click="goToRecord(item,[],[], $event)">
                  <td >
                    <i style="cursor: move" class="fa fa-arrows sortHandle"></i>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>
                    <div class="edit">
                      <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                    </div>
                  </td>
                </tr>
              </template>
            </draggable>
          </table>


        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Col, Input, Table, TableColumn, Row, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Col)
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Row)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      draggable
      // GeneralTopBar
    },
    data () {
      return {
        pages: [],
        loading: true
      }
    },
    computed: {
      ...mapFields(['title', 'description'])
    },
    created () {
      this.getData()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.getData()
      },
      getData () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          sort_order: 'asc'
        }
        var self = this
        this.apiRequest('/settings/infopages', 'GET', data, function (response) {
          if (response.status === true) {
            self.pages = response.data
            self.loading = false
          }
        })
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/custom-info-pages/edit/')
      },
      adjustSort (evt) {
        if (this.pages.length > 1) {
          var idx = evt.newIndex
          var after, before, sortOrder

          if (idx === 0) {
            before = 0
            after = this.pages[idx + 1].sort_order
          } else if ((idx + 1) === this.pages.length) {
            before = this.pages[idx - 1].sort_order
            after = parseFloat(before) + 1
          } else {
            before = this.pages[idx - 1].sort_order
            after = this.pages[idx + 1].sort_order
          }

          sortOrder = (parseFloat(before) + parseFloat(after)) / 2
          var id = this.pages[idx].id

          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }
          this.apiRequest('/settings/infopages/' + id, 'PUT', data, (response) => {
            if (response.status !== true) {
              swal(
                {
                  title: '',
                  text: this.$t('validations.dataCouldNotBeSaved'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          })
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/InfoPagesCustom/CustomInfoPages.vue